import {
  Box, DashboardModule, Link,
} from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useOrderBundle'
import useOrderBundles from '@hooks/useOrderBundles'

import OrderBundleListItem from './OrderBundleListItem'

const OrderBundles = (props: {serviceProductId: number}) => {
  const { serviceProductId } = props

  const options = {
    filters: { service_product_id: serviceProductId },
    performHttpRequests: !!serviceProductId,
    requestOptions: { include_order_bundle_service_product_ids: true },
  }

  const orderBundlesPayload = useOrderBundles(options)

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredOrderBundles,
    filteredOrderBundlesCount,
    hasFilteredOrderBundles,
    loading,
  } = orderBundlesPayload

  const { orderBundlesIndexUrl } = generateUrls()

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-bundles' }}
      title="Bundles"
      loading={loading}
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredOrderBundles && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Bundles present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              You can assign the product to a bundle <Link href={orderBundlesIndexUrl}>here</Link>.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredOrderBundles && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredOrderBundles.map(orderBundleListItem => (
              <OrderBundleListItem
                key={orderBundleListItem.id}
                orderBundleListItem={orderBundleListItem}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredOrderBundlesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}
export default OrderBundles
